import { render, staticRenderFns } from "./partmoduleEdit.vue?vue&type=template&id=6f3048af&scoped=true&"
import script from "./partmoduleEdit.vue?vue&type=script&lang=js&"
export * from "./partmoduleEdit.vue?vue&type=script&lang=js&"
import style0 from "./partmoduleEdit.vue?vue&type=style&index=0&id=6f3048af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3048af",
  null
  
)

export default component.exports